import { computed, ref } from "vue";
import { toRef, tryOnBeforeMount } from "@vueuse/core";
export function useNinjaToasterContainer(_theme) {
  const theme = toRef(_theme);
  const container = ref(null);
  const containerId = computed(() => theme.value?.containerId ?? "nt-container");
  tryOnBeforeMount(() => {
    container.value = document.getElementById(containerId.value);
    if (!container.value) {
      container.value = document.createElement("div");
      container.value.id = containerId.value;
      document.body.appendChild(container.value);
    }
    if (theme.value?.containerClass) {
      container.value.className = Array.isArray(theme.value.containerClass) ? theme.value.containerClass.join(" ") : theme.value.containerClass;
    }
  });
  return {
    container,
    containerId
  };
}
